import { useTranslations } from 'next-intl'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  BoxProps,
  Flex,
  Text,
} from '@chakra-ui/react'

interface IProps extends BoxProps {
  questions?: string[]
  translationKey?: string
}

export function Faq({ questions, translationKey = 'compass-wallet', ...rest }: IProps) {
  const t = useTranslations()
  const faqs = questions ? questions : [
    'how-to-be-verified',
    'what-currencies',
    'can-i-use',
    'how-do-i-pay',
    'how-do-i-receive-rewards',
  ]
  return (
    <Box {...rest}>
      <Text
        textAlign="center"
        fontWeight="700"
        fontSize={{ base: '25px', xl: '30px' }}
        lineHeight={{ base: '30px', md: '30px', xl: '36px' }}
      >
        {t('compass-wallet.faqs.title')}
      </Text>
      <Box mt={{ base: '23px', md: '33px', xl: '43px' }}>
        <Accordion allowMultiple>
          {faqs.map((item) => {
            return (
              <AccordionItem
                key={item}
                borderColor="gray.220"
                borderWidth="1px"
                mb={2}
              >
                <Box>
                  <AccordionButton
                    padding={{ base: '14px', md: '16px', xl: '20px' }}
                  >
                    <Flex width="100%" justifyContent="space-between">
                      <Text
                        textAlign={{ base: 'left', md: 'center' }}
                        fontSize={{ base: '14px', md: '16px', xl: '20px' }}
                        lineHeight={{ base: '20px', md: '20px', xl: '24px' }}
                        fontWeight="700"
                      >
                        {t(`${translationKey}.faqs.${item}.title`)}
                      </Text>
                      <AccordionIcon
                        color="brand.600"
                        boxSize={{ base: 5, md: 7 }}
                      />
                    </Flex>
                  </AccordionButton>
                </Box>
                <AccordionPanel>
                  <Text
                    fontSize={{ base: '13px', md: '15px', xl: '18px' }}
                    lineHeight={{ base: '22px', md: '20px', xl: '24px' }}
                  >
                    {t.rich(`${translationKey}.faqs.${item}.description`, {
                      br: () => <br />,
                    })}
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            )
          })}
        </Accordion>
      </Box>
    </Box>
  )
}
